/* istanbul ignore file */
export * from './SearchProductCard';
